import React, { useEffect, useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Card, CardBody, InputProps, List, Table } from 'reactstrap';
import EngineConfigurationPanel from './EngineConfigurationPanel';
import DefineModelInputsPanel from './ModelInputSection/DefineModelInputsPanel';
import DefineModelOutcomes from './ModelOutcomesSection/DefineModelOutcomes';
import { DATA_TYPES_LIST } from '../../constants';
import { useFormContext } from 'react-hook-form';
import { InterfaceTypes } from '../../enums';

const AIEngineConfiguration = ({ formValues }) => {
  const [openPanel, setOpenPanel] = useState('engineConfig');
  const [dataTypes, setDataTypes] = useState(DATA_TYPES_LIST);

  const {
    register,
    getValues,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const watchInterfaceType = watch('interfaceType', 'Form');

  const toggle = (id) => {
    // console.log('id', id);
    if (openPanel === id) {
      setOpenPanel('');
    } else {
      setOpenPanel(id);
    }
  };

  useEffect(() => {
    if (watchInterfaceType === InterfaceTypes.Form) {
      const newDataTypes = DATA_TYPES_LIST.filter((type) => type.name !== 'Dictionary' && type.name !== 'EmbedInputs');
      setDataTypes(() => newDataTypes);
    } else if (watchInterfaceType === InterfaceTypes.Chatbot) {
      setDataTypes(() => (DATA_TYPES_LIST));
    }
  }, [watchInterfaceType]);

  return (
    <Card className="card-model">
      <CardBody className="ai-engine-content">
        <Accordion flush open={openPanel} toggle={toggle}>
          <AccordionItem>
            <AccordionHeader targetId="engineConfig">AI Engine Configuration</AccordionHeader>
            <AccordionBody accordionId="engineConfig">
              {openPanel === 'engineConfig' && <EngineConfigurationPanel formValues={formValues} />}
            </AccordionBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionHeader targetId="defineModelInputs">Define Model Inputs</AccordionHeader>
            <AccordionBody accordionId="defineModelInputs">
              {openPanel === 'defineModelInputs' && <DefineModelInputsPanel formValues={formValues} dataTypes={dataTypes} />}
            </AccordionBody>
          </AccordionItem>
          <AccordionItem>
            <AccordionHeader targetId="defineModelOutcomes">Define Model Outcomes</AccordionHeader>
            <AccordionBody accordionId="defineModelOutcomes">
              {openPanel === 'defineModelOutcomes' && <DefineModelOutcomes formValues={formValues} dataTypes={dataTypes} />}
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </CardBody>
    </Card>
  );
};

export default AIEngineConfiguration;
